/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：国際化モデル
 *
 * 作成者：2021/11/19 ノア）黄
 * 最終修正者：2021/11/19 ノア）黄
 *
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import ja from './ja.json'

// Init VueI18n
Vue.use(VueI18n)

/**
 * ロケール定義
 *
 * @readonly
 * @enum {string}
 */
export enum Locales {
  /**
   * 日本語
   */
  JA = 'ja'
}

/**
 * デフォルトロケール定義
 *
 * @constant
 */
export const defaultLocale = Locales.JA

/**
 * 多言語メッセージ
 *
 * @constant
 */
export const messages = {
  [Locales.JA]: ja
}

/**
 * VueI18nのインスタンス
 */
export const i18n = new VueI18n({
  messages,
  locale: Locales.JA,
  fallbackLocale: defaultLocale
})
